// extracted by mini-css-extract-plugin
module.exports = {"track":"Switch_track__JcXL_","dot":"Switch_dot__YjHI2"};